import { v4 as uuidv4 } from "uuid";

export const classNames = (
  ...classes: (string | boolean | undefined | null)[]
) => {
  return classes.filter(Boolean).join(" ");
};

export const getUUID = () => {
  return uuidv4();
};

export const isEmoji = (str: string) => {
  const emojiRegex = /[\u{1F600}-\u{1F64F}]/gu;
  return emojiRegex.test(str);
};

export const isSpecialCharacter = (str: string) => {
  const specialCharRegex = /^[!@#$%^&*(),.?":{}_|<>]+$/g;
  return specialCharRegex.test(str);
};

export const getRandomElement = <T>(arr: T[]) => {
  return arr[Math.floor(Math.random() * arr.length)];
};
